import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import i18n from 'i18n/i18n';

export const Tooltip = ({ text, image, ...props }: any) => {
  const { t } = useTranslation('Tooltip', { i18n });
  const [isHovering, setIsHovering] = useState(false);

  const tooltipText = props.selectProps?.tooltipText
    ? props.selectProps.tooltipText
    : text;

  return (
    <div className="Tooltip">
      <div
        className={`TooltipIcon`}
        onMouseEnter={(e) => setIsHovering(true)}
        onMouseLeave={(e) => setIsHovering(false)}
      >
        {image ? (
          <img src={image} alt={t('SSCandidate_Tooltip_Alt_Icon')} />
        ) : (
          '?'
        )}
      </div>

      <div className={`TooltipText ${isHovering ? '' : 'Hidden'}`}>
        {tooltipText}
      </div>
    </div>
  );
};
